module.exports = __webpack_public_path__ + "img/dark-overcast.1dc6e998.svg";